
import { useMemo } from "react";
import { useAddLabelStore, useAuthStore, useChangeLeadStatusStore, useClosableStore, useContextMenuStore, useDealPortfolioStore, useDetailsStore, useDrawMapStore, useDriveTimeStore, useFavoriteStore, useLeadStore, useLeaseCompStore, useListStore, useLocationStore, useMapMarkerStore, useMapRadiusStore, useMapShapeStore, useMapStore, usePopupStore, usePropertyAiGradeStore, usePropertyContactInfoStore, usePropertyStore, useRecentStore, useRecordedSaleStore, useSaleCompStore, useSavedViewStore, useSearchStore, useSegmentedButtonsStore, useSetReminderStore, useStreetViewStore, useTenantInMarketStore, useViewSettingsStore } from "..";
import LocalStorageService from "../services/localStorageService";

const useLogout = (): () => void => {
    const localStorageService = useMemo(() => new LocalStorageService(), []);

    const authStore = useAuthStore();
    const mapStore = useMapStore();
    const leadStore = useLeadStore();
    const leaseCompStore = useLeaseCompStore();
    const saleCompStore = useSaleCompStore();
    const tenantInMarketStore = useTenantInMarketStore();
    const savedViewStore = useSavedViewStore();
    const pipedriveStore = usePopupStore();
    const locationStore = useLocationStore();
    const favoriteStore = useFavoriteStore();
    const propertyStore = usePropertyStore();
    const propertyAiGradeStore = usePropertyAiGradeStore();
    const propertyContactInfoStore = usePropertyContactInfoStore();
    const recordedSaleStore = useRecordedSaleStore();
    const dealPortfolioStore = useDealPortfolioStore();

    const searchStore = useSearchStore();
    const recentStore = useRecentStore();
    const drawMapStore = useDrawMapStore();
    const driveTimeStore = useDriveTimeStore();
    const mapMarkerStore = useMapMarkerStore();
    const mapRadiusStore = useMapRadiusStore();
    const mapShapeStore = useMapShapeStore();
    const streetViewStore = useStreetViewStore();
    const contextMenuStore = useContextMenuStore();
    const popupStore = usePopupStore();
    const listStore = useListStore();
    const detailsStore = useDetailsStore();
    const viewSettingsStore = useViewSettingsStore();
    const closableStore = useClosableStore();
    const segmentedButtonsStore = useSegmentedButtonsStore();
    const setReminderStore = useSetReminderStore();
    const addLabelStore = useAddLabelStore();
    const changeLeadStatusStore = useChangeLeadStatusStore();

    return (): void => {
        localStorageService.clearUserEmail();
        localStorageService.clearPipedriveUserId();
        localStorageService.clearGoogleTilesSession();

        authStore.logout();
        mapStore.clear();
        leadStore.clear();
        leaseCompStore.clear();
        saleCompStore.clear();
        tenantInMarketStore.clear();
        savedViewStore.clear();
        pipedriveStore.clear();
        locationStore.clear();
        favoriteStore.clear();
        propertyStore.clear();
        propertyAiGradeStore.clear();
        propertyContactInfoStore.clear();
        recordedSaleStore.clear();
        dealPortfolioStore.clear();

        searchStore.clear();
        recentStore.clear();
        drawMapStore.clear();
        driveTimeStore.clearForLogout();
        mapMarkerStore.clear();
        mapRadiusStore.clearForLogout();
        mapShapeStore.clear();
        streetViewStore.clear();
        contextMenuStore.clear();
        popupStore.clear();
        listStore.clear();
        detailsStore.clear();
        viewSettingsStore.clear();
        closableStore.clear();
        segmentedButtonsStore.clear();
        setReminderStore.clear();
        addLabelStore.clear();
        changeLeadStatusStore.clear();
    };
};

export default useLogout;